export enum GRADE_STATUS {
  ACTIVE = "active",
  CURRENT = "current",
  NOT_STARTED = "not_started"
}
